import { BaseInputFilter } from "domain/models/base-input-filter"
import { useFunctions } from "presentation/hooks/use-query-functions"
import { MobileRoute, useNavigationStore } from "presentation/mobile/stores/navigation-store"
import { getMobileRoutes } from "presentation/mobile/utils/mobile-routes.util"
import { useAuthStore } from "presentation/stores/use-auth-store"
import { Menu } from "primereact/menu"
import { MenuItem } from "primereact/menuitem"
import { useEffect, useRef } from "react"
import { useNavigate } from "react-router-dom"

const BottomNavigation = () => {

    const navigationStore = useNavigationStore();

    const navigate = useNavigate();
    const menuRef = useRef<Menu>(null);

    const navigateToRoute = (route: string) => {
        navigationStore.setUseSubMenu(false);
        navigationStore.setCurrentSubRoutes([]);
        navigationStore.setPreviousRoute(navigationStore.currentRoute);
        navigate(route);
    }

    // Categories (Dashboard, Mapa de KMs) have no page of their own: open the submenu like the Home does
    const openMenuItem = (item: MobileRoute) => {
        const subRoutes = item.subRoutes ?? [];
        if (subRoutes.length === 0) {
            navigateToRoute(item.route);
        } else if (subRoutes.length === 1) {
            navigateToRoute(subRoutes[0].route);
        } else {
            navigationStore.setCurrentSubRoutes(subRoutes);
            navigationStore.setCurrentCategoryLabel(item.label);
            navigationStore.setUseSubMenu(true);
            navigate("/mobile");
        }
    }

    const moreItems: MenuItem[] = navigationStore.routes.filter(route => !route.showOnBar).map((item) => ({
        label: item.label,
        icon: item.icon,
        command: () => openMenuItem(item)
    }));


    const getBarItems = () => {
        return navigationStore.routes.filter(route => route.showOnBar).map((item) => {
            const isActive = navigationStore.currentRoute === item.name;
            const activeColor = isActive ? "#0f82fd" : "#000000";
            return (
                <div 
                key={item.route} 
                className="flex flex-column flex-1 align-items-center justify-content-center cursor-pointer py-1 gap-1" onClick={() => navigateToRoute(item.route)} 
                style={{ color: activeColor }}>
                    <i className={`${item.icon} text-xl`}/>
                    <span className="text-xs text-center font-medium line-height-1">{item.label}</span>
                </div>
            )
        })
    }


    return (
        <>
            <div 
            className="flex flex-row w-full justify-content-evenly align-items-center px-2 border-top-2"
            style={{ borderColor: "#a7a7a7ad", backgroundColor: "#ffffff", minHeight:"64px", paddingTop:"0.5rem", paddingBottom:"calc(0.75rem + env(safe-area-insert-bottom, 0px))" }}
            >
                {getBarItems()}
                {
                    moreItems.length > 0 && (
                        <div 
                        className="flex flex-column flex-1 align-items-center justify-content-center cursor-pointer py-1 gap-1"
                        style={{color: "#4b5563"}} onClick={(event) => menuRef.current?.toggle(event)}>
                            <i className="pi pi-ellipsis-h text-xl" />
                            <span className="text-xs text-center font-medium line-height-1">Mais</span>
                        </div>
                    )
                }
            </div>
            <Menu model={moreItems} ref={menuRef} id="popup_menu" popup/>
        </>
    )
}
export default BottomNavigation;